"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useRef } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
const testimonials = [{
  author: "Sarah M.",
  quote: "After just two sessions, Bear is moving with such ease on our morning hikes. The clinical approach makes all the difference.",
  position: "Durango Local"
}, {
  author: "David K.",
  quote: "Jessica's expertise as a DPT is evident. She helped our senior lab find comfort and mobility we thought were gone.",
  position: "Durango Local"
}];
export default function ClientSuccessStories() {
  const watermarkRef = useRef<HTMLDivElement>(null);
  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!watermarkRef.current) return;
    const {
      clientX,
      clientY
    } = e;
    const moveX = (clientX / window.innerWidth - 0.5) * 40;
    const moveY = (clientY / window.innerHeight - 0.5) * 40;
    watermarkRef.current.style.transform = `translate(${moveX}px, ${moveY}px)`;
  };
  return <section data-section-id="222908" id="voices-of-the-pack" className="bg-background text-foreground relative overflow-hidden py-24 md:py-36 flex items-center min-h-[80vh]" onMouseMove={handleMouseMove}>
      {}
      <div ref={watermarkRef} className="pointer-events-none absolute inset-0 flex items-center justify-center transition-transform duration-1000 ease-out" aria-hidden="true">
        <span className="text-[20vw] font-serif font-bold leading-none tracking-tighter text-primary/[0.03] select-none">
          DURANGO
        </span>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-8">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="mx-auto w-full max-w-5xl">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center space-y-12 px-4 text-center sm:px-12">
                  <blockquote className="max-w-4xl">
                    <p className="font-serif italic text-3xl font-medium leading-tight tracking-tight md:text-[32px] md:leading-snug text-primary">
                      "{testimonial.quote}"
                    </p>
                  </blockquote>

                  <div className="flex flex-col items-center gap-4">
                    <SafeHydrate><Avatar className="size-14 border border-border/50 bg-accent shadow-sm">
                      <AvatarFallback className="bg-transparent font-sans text-lg text-primary">
                        {testimonial.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div className="space-y-1">
                      <div className="font-default font-semibold tracking-wide text-primary">
                        {testimonial.author}
                      </div>
                      <div className="font-sans text-xs font-medium uppercase tracking-widest text-secondary">
                        {testimonial.position}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="mt-16 flex items-center justify-center gap-6">
            <CarouselPrevious variant="ghost" className="static translate-x-0 translate-y-0 size-12 rounded-lg border border-secondary/20 bg-transparent hover:bg-secondary/5 hover:border-secondary/60 text-secondary/60 hover:text-secondary transition-all duration-300 [&_svg]:size-5 [&_svg]:stroke-[1.5px]" />
            <CarouselNext variant="ghost" className="static translate-x-0 translate-y-0 size-12 rounded-lg border border-secondary/20 bg-transparent hover:bg-secondary/5 hover:border-secondary/60 text-secondary/60 hover:text-secondary transition-all duration-300 [&_svg]:size-5 [&_svg]:stroke-[1.5px]" />
          </div>
        </Carousel>
      </div>
    </section>;
}